import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'comment-indicator',
	templateUrl: './comment-indicator.component.html',
	styleUrls: ['./comment-indicator.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CommentIndicatorComponent {
	@Input() public unviewedComments: number;

	constructor () {}
}
